<template>
  <nav id="sidebar">
    <img src="../assets/mark_blue_small.png" class="logo">
    <div class="list-group list-group-flush">
      <router-link :to="{ name: 'Dashboard', params: {} }"><a class="list-group-item" @click="setViewMode('dashboardHome')"><i class="far fa-home"></i> Dashboard</a></router-link>
      <a class="list-group-item" @click="setViewMode('manageLists')"><i class="far fa-list"></i> Lists</a>
      <a class="list-group-item" @click="setViewMode('settings')"><i class="fas fa-cog"></i> Settings</a>
      <a class="list-group-item" @click="logout"><i class="far fa-sign-out-alt"></i> Logout</a>
      <div class="card">
        <div class="card-body">
          <p><router-link :to="{ name: 'UserProfile', params: {id: currentUser.uid} }">{{ userProfile.name }}</router-link><br><small>{{ userProfile.company }}</small></p>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import { mapState } from 'vuex'
  const fb = require('../firebaseConfig.js')

  export default {
    computed: {
      ...mapState(['userProfile', 'currentUser'])
    },
    methods: {
      setViewMode(viewMode) {
        this.$emit('setViewMode', viewMode)
        this.$router.push('/dashboard/lists')
      },
      logout() {
        fb.auth.signOut().then(() => {
          this.$store.dispatch('clearData')
          this.$router.push('/login')
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Navigation.vue